<template>
    <div class="container">
        <p v-if="profile.username">

            <strong>Name:</strong> {{profile.username}}<br>
            <strong>Email:</strong> {{profile.email}}
        </p>
    </div>
</template>


<script>
    import { mapState } from 'vuex'
    export default {
        name: 'account',
        computed: mapState({profile: state => state.user.profile})
    }
</script>